import {action, observable} from 'mobx';
import http from '../../http'

class BookingHistoryStore {
    _authStore;
    _routerStore;
    @observable last = [];
    @observable accepted = [];
    @observable waiting = [];
    @observable total_count = 0;
    @observable count_cur_month = 0;
    @observable bonuses = 0;
    @observable loading = true;
    @observable firstLoad = true;
    @observable errorLoaded = false;
    @observable show_cancel_dialog = false;
    @observable cancel_order_id = null;


    constructor(routerStore, authStore) {
        this._routerStore = routerStore
        this._authStore = authStore
    }

    load = async () => {
        if (this.firstLoad) {
            Promise.resolve(() => true)
                .then(this._authStore.getAuthFromApp)
                .then(() => this.firstLoad = false)
                .then(this.getHistory)
        }
    };

    cancelOrderClick = async (id) => {
        return await Promise.resolve()
            .then(() => this.cancel_order_id = id)
            .then(() => this.show_cancel_dialog = true)
    }


    cancelOrderCallback = async () => {
        return await Promise.resolve()
            .then(() => this.loading = true)
            .then(() => this.show_cancel_dialog = false)
            .then(() => this.cancelOrder(this.cancel_order_id))
            .catch(() => this.cancel_order_id = null)
            .then(() => this.getHistory())
            .then(() => this.loading = false)
    }


    @action
    cancelOrder = async () => {
        return http.post(`/appointments/cancel-order?id=${this.cancel_order_id}`)
            .then(({data}) => {
                this.openAlert = true
                this.alertMessage = data.content.message
                this.alertMessageType = 'success';
            })
            .catch(({response}) => {
                if (response && response.data && response.data.message) {
                    this.alertMessage = response.data.message
                } else {
                    this.alertMessage = 'Что-то пошло не так :('
                }
                this.openAlert = true
                this.alertMessageType = 'error';
            })
    };

    @action
    getHistory = async () => {
        return http.get(`/appointments/history`)
            .then(({data}) => {
                this.last = data.content.last
                this.accepted = data.content.accepted
                this.waiting = data.content.waiting
                this.total_count = data.content.total_count
                this.count_cur_month = data.content.count_cur_month
            })
            .then(() => this.loading = false)
            .catch(({response}) => {
                if (response.status === 401) {
                    this.loading = false
                }
                this.errorLoaded = true
            })
    };
}

export {BookingHistoryStore};
